import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { store as storeNotification } from 'react-notifications-component';

import { editDashboards } from '../../redux/actions/dashboards';
import hourFields from '../../config-panel-dash/hourFields';
import noLimitConfigFields from '../../config-panel-dash/noLimitConfigFields';
import config from '../../api/config.json';

const DashTable = props => {
  const notificationConfig = {
    container: 'top-center',
    animationIn: ['animated', 'fadeIn'],
    animationOut: ['animated', 'fadeOut'],
    inset: 'top',
    dismiss: {
      duration: 2000,
      showIcon: false
    }
  };
  const extStatusIcon = (extStatus, callStatus) => {
    switch (extStatus) {
      case 'gancho':
        return 'icon-call-end';
      case 'ring':
        return 'icon-ring-volume';
      case 'iniciando':
        return 'icon-dialpad';
      case 'saindo':
        return 'icon-settings-phone';
      case 'consulta':
        return 'icon-phone-paused';
      case 'finalizando':
        return 'icon-phonelink-erase';
      case 'recebida':
        return 'icon-call-received';
      case 'feita':
        return 'icon-call_made';
      case 'interna': {
        if (callStatus === 'recebida') {
          return 'icon-call-received';
        } else {
          return 'icon-call-made';
        }
      }
      default: {
        if (callStatus === 'recebida') {
          return 'icon-call-received';
        } else if (callStatus === 'feita') {
          return 'icon-call-made';
        } else {
          return 'icon-call';
        }
      }
    }
  };
  const dispatch = useDispatch();
  const dashboards = useSelector(state => state.dashboards);
  const {
    dash,
    el,
    sessionUser,
    modalShowChangeStatus,
    setModalShowChangeStatus,
    dataModalChangeStatus,
    setDataModalChangeStatus
  } = props;
  let reports = [];
  const rpts = props.reports.slice();
  const {
    type,
    fields,
    fontHeader,
    fontContent,
    configFields,
    members,
    typeDisplay
  } = el;
  const fieldsHeaderTable = fields.filter(field => field.visible);
  const fieldsVisible = fieldsHeaderTable.map(field => field.id);
  let { orderBy } = el;
  if (typeDisplay && typeDisplay !== 'ALL' && members) {
    if (type !== 'TC' && type !== 'TU') {
      reports = rpts.filter(rpt => members.includes(rpt._id));
    } else if (type === 'TU') {
      reports = rpts.filter(rpt => members.includes(rpt.user));
    } else if (type === 'TC') {
      reports = rpts.filter(
        rpt => members.includes(rpt.from) || members.includes(rpt.extension)
      );
    }
  } else {
    reports = [...rpts];
  }
  // Não tem atribuição porque sort e reverse modifica o array
  if (orderBy && fieldsVisible.includes(orderBy.field)) {
    reports.sort((a, b) => {
      if (a[orderBy.field] && b[orderBy.field]) {
        return String(a[orderBy.field]).localeCompare(
          String(b[orderBy.field]),
          undefined,
          {
            numeric: true,
            sensitivity: 'base'
          }
        );
      } else {
        return 0;
      }
    });
    if (orderBy.sorting === 'desc') {
      reports.reverse();
    }
  } else if (fieldsVisible.length) {
    // Caso a ordenação não esteja configurada ordena pela primeira coluna
    const firstField = fieldsVisible[0];
    reports.sort((a, b) => {
      if (a[firstField] && b[firstField]) {
        return a[firstField].localeCompare(b[firstField], undefined, {
          numeric: true,
          sensitivity: 'base'
        });
      } else {
        return 0;
      }
    });
    orderBy = { field: firstField, sorting: 'asc' };
  }

  const sortedTableSaveConfig = (dash, panel, field) => {
    if (!dashboards.isFetching) {
      if (dashboards.enableTransition) {
        storeNotification.addNotification({
          ...notificationConfig,
          title: 'Desabilite a transição para ordenar a tabela',
          message: ' ',
          type: 'danger'
        });
      } else {
        if (!panel.orderBy) {
          panel.orderBy = { field, sorting: 'asc' };
        } else {
          const sorting =
            panel.orderBy.field !== field || panel.orderBy.sorting === 'desc'
              ? 'asc'
              : 'desc';
          panel.orderBy = { field, sorting };
        }
        const items = dash.items.map(item =>
          item.i !== panel.i ? item : panel
        );
        const newDash = { ...dash, items };
        dispatch(editDashboards({ ...newDash }));
      }
    }
  };

  if (modalShowChangeStatus && el.type === 'TU' && dataModalChangeStatus.user) {
    const data = reports.find(
      rpt => rpt.extension === dataModalChangeStatus.extension
    );
    if (data) {
      setDataModalChangeStatus({ ...data });
    } else {
      setModalShowChangeStatus(false);
      setDataModalChangeStatus({});
    }
  }

  return (
    <table className="dataTable table-reports table table-bordered table-striped">
      <thead>
        <tr>
          {fieldsHeaderTable.map(field => {
            const { id, title, text } = field;
            const headerStyle = { fontSize: parseInt(fontHeader || 12) };

            try {
              if (configFields) {
                const config = configFields.find(config =>
                  Object.keys(config).includes(id)
                );
                if (config && config[id]) {
                  const { backColorHeader, fontColorHeader } = config[id];
                  headerStyle.backgroundColor =
                    backColorHeader.length > 4 ? backColorHeader : undefined;
                  headerStyle.color =
                    fontColorHeader.length > 4 ? fontColorHeader : undefined;
                }
              }
            } catch (err) {
              console.error(err);
            }
            return (
              <th
                key={id}
                scope="col"
                title={title}
                style={{ ...headerStyle }}
                onClick={() => sortedTableSaveConfig(dash, el, id)}
                className={
                  orderBy.field === id
                    ? `sorting_${orderBy.sorting}`
                    : 'sorting'
                }
              >
                {text}
              </th>
            );
          })}
        </tr>
      </thead>
      <tbody>
        {reports.map((report, position) => {
          return (
            <tr
              key={`tr_${position}`}
              style={{ fontSize: parseInt(fontContent) }}
            >
              {fieldsVisible.map(field => {
                const borderLimit = {
                  padding: '2px',
                  borderRadius: '10px',
                  border: '6px solid transparent',
                  borderColor: 'transparent'
                };
                try {
                  if (configFields && !noLimitConfigFields.includes(field)) {
                    const config = configFields.find(config =>
                      Object.keys(config).includes(field)
                    );
                    if (config && config[field]) {
                      const {
                        limit1Color,
                        limit1Value,
                        limit2Color,
                        limit2Value,
                        limit3Color,
                        limit3Value
                      } = config[field];
                      const limits = [
                        { limit: limit1Value, color: limit1Color },
                        { limit: limit2Value, color: limit2Color },
                        { limit: limit3Value, color: limit3Color }
                      ].sort((a, b) => {
                        return String(a.limit).localeCompare(
                          String(b.limit),
                          undefined,
                          {
                            numeric: true,
                            sensitivity: 'base'
                          }
                        );
                      });

                      const l1 = limits[0].limit;
                      const l2 = limits[1].limit;
                      const l3 = limits[2].limit;
                      const c1 = limits[0].color;
                      const c2 = limits[1].color;
                      const c3 = limits[2].color;

                      if (l1 !== l2 && l2 !== l3 && l3 !== l1) {
                        if (
                          hourFields.includes(field) &&
                          String(report[field]).split(' ').length > 1
                        ) {
                          borderLimit.borderColor = c3;
                        } else {
                          const dataField = parseInt(
                            String(report[field]).replace(/:/g, ''),
                            10
                          );
                          if (dataField >= l3) {
                            borderLimit.borderColor = c3;
                          } else if (dataField === l2) {
                            borderLimit.borderColor = c2;
                          } else if (dataField === l1) {
                            borderLimit.borderColor = c1;
                          } else if (dataField > l1 && dataField < l2) {
                            borderLimit.borderColor = c1;
                          } else if (dataField > l2 && dataField < l3) {
                            borderLimit.borderColor = c2;
                          }
                        }
                      }
                    }
                  }
                } catch (err) {
                  console.error(err);
                }
                return (
                  <td key={`td_${field}`}>
                    {field === 'status' && type === 'TU' ? (
                      <span>
                        {report.status === 'disponível' &&
                        report.extStatus !== 'gancho'
                          ? 'ocupado'
                          : report[field]}
                      </span>
                    ) : field === 'userName' && type === 'TU' ? (
                      <div>
                        <img
                          className="bg-white rounded-circle align-middle"
                          width={parseInt(fontContent)}
                          height={parseInt(fontContent)}
                          style={{
                            cursor: `${
                              ['M', 'S'].includes(sessionUser.type)
                                ? 'pointer'
                                : 'auto'
                            }`
                          }}
                          src={`${config.protocol}://${config.ipServerGW}:${config.portServerGW}/api/users/image/${report.user}`}
                          alt="Avatar"
                          onClick={() => {
                            setDataModalChangeStatus(report);
                            setModalShowChangeStatus(!modalShowChangeStatus);
                          }}
                        />
                        &nbsp;&nbsp;
                        <span className="align-middle">
                          <i
                            className="fa fa-circle"
                            style={{
                              fontSize: fontContent - 5,
                              color: `${
                                report.status.toLowerCase() === 'indisponível'
                                  ? '#757575'
                                  : report.status.toLowerCase() === 'disponível'
                                  ? '#2DA58A'
                                  : '#D4565F'
                              }`
                            }}
                          />
                          &nbsp;{report[field]}&nbsp;&nbsp;&nbsp;
                        </span>
                      </div>
                    ) : (
                      <React.Fragment>
                        {field === 'extension' && type === 'TU' && (
                          <React.Fragment>
                            <span>&nbsp;</span>
                            <span
                              className={extStatusIcon(
                                report.extStatus,
                                report.call
                              )}
                              style={{
                                width: `${fontContent}px`,
                                height: `${fontContent}px`
                              }}
                            ></span>
                            <span>&nbsp;</span>
                          </React.Fragment>
                        )}
                        <span style={{ ...borderLimit }}>{report[field]}</span>
                        {field === 'extension' && type === 'TU' && (
                          <span>&nbsp;&nbsp;</span>
                        )}
                      </React.Fragment>
                    )}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default DashTable;

DashTable.propTypes = {
  el: PropTypes.object,
  reports: PropTypes.array,
  dash: PropTypes.object,
  sessionUser: PropTypes.object,
  modalShowChangeStatus: PropTypes.bool,
  setModalShowChangeStatus: PropTypes.func,
  dataModalChangeStatus: PropTypes.object,
  setDataModalChangeStatus: PropTypes.func
};
